import { PanelEditReseller } from "../../../UI/Resellers/Edit/PanelEditReseller";

const EditReseller = () => {
  return (
    <div>
      <PanelEditReseller />
    </div>
  );
};

export default EditReseller;
